/**
 * Relative platform assign URL for engagement REST custom actions.
 * Action-engine resolves against AMP_PLATFORM_URL and injects service-account auth at runtime.
 */
export const getPlatformTrainingCreateUrl = (): string => {
    const version = process.env.PLATFORM_API_VERSION || process.env.INTERNAL_API_VERSION || 'v1';
    return `/platform/${version}/trainings/create/{{user.id}}`;
};
